// @ts-strict-ignore
import { WidgetFrame } from "components/layout/WidgetFrame";
import { WidgetWithQueryParameters } from "components/layout/WidgetFrame/widget.types";
import { type Regions, KPI, getThresholdsFromRegions, getActiveRegion, toKPIChartDataPoints } from "components/ui/KPI";
import { formatKPIValue } from "components/ui/KPI";
import { useDataSourceNewApproach } from "features/data-source/useDataSourceNewApproach";
import { routes } from "routes";
import { generatePath } from "routes/routes.utils";

type Props = WidgetWithQueryParameters<"dateFrom" | "dateTo">;

const ManHoursHighKPIWidget = (props: Props) => {
    const { queryParameters } = props;
    const title = "Man-Hours High";

    const dataSourceParameters = { ...queryParameters, KPI: 5, technicianCode: "" };

    const chartDataSource = useDataSourceNewApproach<any>("dashboard/spent-hours/chart", dataSourceParameters);
    const textDataSource = useDataSourceNewApproach<any>("dashboard/spent-hours/text", dataSourceParameters);
    const { data, lastDataPoint } = toKPIChartDataPoints(chartDataSource?.data ?? [], {
        getLabel: (x) => formatKPIValue(x, { suffix: "%" }),
    });
    const { TextValue: additionalValue, TextLabel: additionalTitle } = textDataSource?.data?.[0] ?? {};

    const regions = [
        { type: "region", color: "red" },
        { type: "threshold", value: 25, regionIfEqual: "lower" },
        { type: "region", color: "orange" },
        { type: "threshold", value: 10, regionIfEqual: "upper" },
        { type: "region", color: "green" },
    ] satisfies Regions;
    const thresholds = getThresholdsFromRegions({ regions, lastDataPoint });
    const activeRegion = getActiveRegion({ regions, lastDataPoint });
    const color = activeRegion?.color;

    return (
        <>
            <WidgetFrame.Title
                title={title}
                icon={"lely-icon-calendar"}
                size={"sm"}
                link={generatePath(routes.manHoursHigh)}
            >
                <WidgetFrame.Title.Information lastImportType={"middleware"} pageId={207487161}>
                    Percentage of worked hours marked outside regular hours
                </WidgetFrame.Title.Information>
            </WidgetFrame.Title>
            <WidgetFrame.KPI dependencies={[chartDataSource, textDataSource]}>
                <KPI.LastValue title={"Last Selected Full 12 Months"} value={lastDataPoint?.label} color={color} />
                <KPI.AdditionalValue title={additionalTitle} value={formatKPIValue(additionalValue, { suffix: "%" })} />
                <KPI.Chart data={data} color={color} thresholds={thresholds} />
            </WidgetFrame.KPI>
        </>
    );
};

export { ManHoursHighKPIWidget };
